<template>
    <div>
        <container-loader v-if="!isPrinterTypesLoaded"></container-loader>
        <div v-else>
            <b-row>
                <b-col sm="12">
                    <h5 class="highlight mt-2">{{$t('apps.magicFix.appName')}}</h5>
                    <div class="separator"></div>
                </b-col>
                <b-col sm="8" lg="9">
                    <p>{{$t('files.modal.repair.info')}}</p>
                    <p class="highlight mt-3">{{$t('files.modal.repair.notes')}}</p>
                </b-col>
                <b-col sm="4" lg="3" class="d-none d-sm-flex">
                    <Illustration class="illustration"></Illustration>
                </b-col>
            </b-row>
            <div class="separator"></div>
            <b-row v-if="log" md="12">
                <b-col md="12">
                    <div class="scroller inp inp--100" v-html="log"></div>
                </b-col>
            </b-row>
            <b-row class="mb-4" v-else>
                <b-col lg="6" sm="12">
                    <label>{{$t('files.base.selectPrinters')}}</label>
                    <printer-select :className="'sel inp inp--100 mb-3'" :file-id="fileId" v-model="printerSelect"></printer-select>
                    <!--<select class="sel inp inp&#45;&#45;100 mb-3" v-model="printerSelect">-->
                        <!--<option v-for="(item, index) in getPrinterTypes" :key="index" :value="item.id">{{item.description}}</option>-->
                    <!--</select>-->
                </b-col>
                <b-col lg="6" sm="12">
                    <b-checkbox v-model="move" class="check mt-2 mt-lg-4" >{{$t('files.modal.repair.moveObject')}}</b-checkbox>
                    <b-checkbox v-model="rotate" class="check" >{{$t('files.modal.repair.rotateObject')}}</b-checkbox>
                    <b-checkbox v-model="resize" class="check" >{{$t('files.modal.repair.autoSize')}}</b-checkbox>
                    <p class="tip">{{$t('files.modal.repair.scaleObject')}}</p>
                </b-col>
            </b-row>



           <!--<div v-if="log">-->
               <!--<div class="scroller" v-html="log"></div>-->
           <!--</div>-->
           <!--<div v-else>-->
               <!--<div>-->
                   <!--<lable>Select 3D Printer</lable>-->
                   <!--<select class="sel inp" v-model="printerSelect">-->
                       <!--<option v-for="(item, index) in getPrinterTypes" :key="index" :value="item.id">{{item.description}}</option>-->
                   <!--</select>-->

                   <!--<b-checkbox v-model="move" class="check" >Move object to center of build plate</b-checkbox>-->
                   <!--<b-checkbox v-model="rotate" class="check" >Rotate object for printer specific build plate</b-checkbox>-->
                   <!--<b-checkbox v-model="resize" class="check" >Auto-resize object for printing</b-checkbox>-->
                   <!--<p>-->
                       <!--*Scales object bigger than 50 cm by 10x down and objects smaller than 2mm by 10x up-->
                   <!--</p>-->
               <!--</div>-->
           <!--</div>-->


           <div class="modal__footer--inside modal__footer--color">
               <div class="modal__footer--left">
                   <b-button v-if="!isProcess" variant="-ternary btn--outline" @click="cancel()">
                       {{$t('buttons.cancel')}}
                   </b-button>
                   <container-loader class="modal__footer--loader" v-if="isProcess && state < 3"></container-loader>
               </div>
               <div class="modal__footer--right">
                   <b-button v-if="!isProcess" variant="-primary" @click="handleDeletePrinter()">
                       {{$t('apps.magicFix.fixModel')}}
                   </b-button>
                   <b-button v-else="" variant="-primary" @click="cancel()">
                       {{$t('printers.job.finish')}}
                   </b-button>
               </div>
           </div>
       </div>
   </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import Vue from "vue";
  import EventBus from "@/event/event-bus";
  import Illustration from "@/components/graphics/MagicFixIllustration.vue";
  import PrinterSelect from "@/components/printers/PrinterSelect";

  export default {
    name: "RepairFile",
    props:['fileId'],
    data(){
      return {
        isProcess: false,
        move: true,
        rotate: true,
        resize: true,
        printerSelect: null,
        job_id: null,
        log: null,
        state: 0

      }
    },
    components: {
        Illustration,
        PrinterSelect
    },
    computed: {
      ...mapGetters(['isPrinterTypesLoaded', 'getPrinterTypes']),
    },
    methods: {
      ...mapActions(['fetchPrinterTypes', 'savePrinterTypeByFile']),
      handleDeletePrinter(){
       this.savePrinterTypeByFile(this.fileId, this.printerSelect);
       this.isProcess = true;
       let data = {
          settings_printer_type_id: this.printerSelect,
          settings_move: this.move,
          settings_rotate: this.rotate,
          settings_zoom: this.resize,
          settings_file_id: this.fileId,
        }
        Vue.axios.post('/apps/stlmagicfix/convert/' + this.fileId , data).then( (response)  => {
          // handle success
          if(!response.data.error){
            this.job_id = response.data.job_id
            this.getLog()
              EventBus.$emit('project:open');
          }
        })
      },

      getLog(){
        Vue.axios.post('/apps/stlmagicfix/getstatus/' + this.job_id ).then((response) => {
          // handle success
          if(!response.data.error){
            this.log = response.data.result.log
            this.state = response.data.result.state
            if(this.state < 3){
              setTimeout(()=>{ this.getLog() }, 2000)
            } else {
                this.savePrinterTypeByFile({fileId: response.data.result.output_file_id, printerTypeId: this.printerSelect});
            }
          }
        })
      },

      cancel(){
        this.$parent.$parent.hide();
      }
    },
    created() {
      if(!this.isPrinterTypesLoaded){
        this.fetchPrinterTypes()
      }
    }
  }
</script>

<style scoped lang="scss">
    .scroller{
        height: 300px;
        overflow-y: scroll;
        background-color: white;
        font-size: 14px;
        line-height: 18px;
        font-family: "Courier new" ,"Courier", SANS-SERIF;
        padding: 20px;
    }
    .tip{
        font-size: 12px;
        line-height: 14px;
        color: #808080;
        margin-top: 19px;
        max-width: 320px;
    }
    .illustration{
        display: block;
        height: 150px;
        width: 150px;
        position: absolute;
        bottom: -5px;
        right: 15px;
    }
</style>
